import React, { useEffect, useState, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import Form from 'react-bootstrap/Form';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import moment from 'jalali-moment';
import { AttachFileCreate, AttachFileDelete, AttachFileUpdate, baseUrl, SearchProductUserComment,deleteProductUserComment } from '../../../utils/api';
import { Skeleton } from 'primereact/skeleton';

import useToastNotification from '../../../hooks/useToastNotification';
import Loader from '../../loader/loader'
import Trash from '../../../assets/icons/trash.svg';
import WhiteTrash from '../../../assets/icons/white-trash.svg'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

function Banner() {
    const { showError, showSuccess } = useToastNotification();
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);

    const loadContactUs = async (page = pageIndex, size = pageSize) => {
        setLoading(true)
        try {
            let response = await SearchProductUserComment({  pageIndex: page,
                pageSize: size,});
            setItems(response.data.data.items);
            setTotalRecords(response.data.data.total);
            setLoading(false)
        } catch (error) {
            setLoading(false)
            showError("خطا در بارگذاری اطلاعات");
        }
    };

    const loadPage = async () => {
        await loadContactUs();
    };

    useEffect(() => {
        loadPage();
    }, []);

    // تبدیل تاریخ میلادی به شمسی
    const formatJalaliDate = (date) => {
        return moment(date).locale('fa').format('YYYY/MM/DD');
    };

    // بدنه سفارشی برای ستون تاریخ
    const dateBodyTemplate = (rowData) => {
        return formatJalaliDate(rowData.createDate);
    };
    const skeletonBodyTemplate = () => {
        return <Skeleton width="100%" height="1.5rem" />;
    };

    const handlePagination = (event) => {
        // Update the pageIndex and pageSize based on the event
        setPageIndex(event.page + 1);
        setPageSize(event.rows);

        // Trigger a data fetch for the new page
        loadContactUs(event.page, event.rows);
    };
    const actionTemplate = (rowData) => {
        return (
            <div className='d-flex justify-content-center gap-2' style={{ borderRight: '0.5px solid #D2D2D2' }}>
        
                <img
                    src={Trash}
                    alt="delete"
                    className="cursor-pointer mx-1"
                    onClick={() => openDeleteDialog(rowData)}
                    style={{ width: '24px', height: '24px' }}
                />
            </div>
        );
    };

        const openDeleteDialog = async (rowData) => {
            document.body.style.overflow = 'hidden'; // غیرفعال کردن اسکرول
    
            confirmDialog({
                message: 'آیا از حذف آیتم اطمینان دارید؟',
                header: 'حذف آیتم',
                defaultFocus: 'reject',
                maskClassName: 'flex',
                headerClassName: '!pr-1 !pl-1',
                acceptClassName: 'btn btn-danger mx-1',
                rejectClassName: 'btn btn-secondary mx-1',
                acceptLabel: 'حذف',
                rejectLabel: 'انصراف',
                resizable: false,
                accept: () => {
                    deleteItem(rowData)
                    document.body.style.overflow = 'auto';
                },
                reject: () => {
                    document.body.style.overflow = 'auto'; // فعال کردن مجدد اسکرول
                },
            });
        };
            const deleteItem = async (item) => {
                await deleteProductUserComment({ id: item.id }).then(() => {
                    showSuccess("عملیات با موفقیت انجام شد");
                    setItems(old => old.filter(filter => item.id !== filter.id));
                }).catch(error => {
                    showError(error.response.data.message);
                });
            };
    return (
        <>
            {/* <div className="w-100 d-flex justify-content-between bg-white p-2 align-items-center border-solid border">
            </div> */}
            <div>
                <DataTable
                        value={items}
                        size="small"
                        paginator
                        rows={pageSize}
                        totalRecords={totalRecords}
                        lazy
                        onPage={handlePagination}
                        first={(pageIndex - 1) * pageSize} // Current first record index
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                        tableStyle={{ minWidth: '50rem' }}
                >
                    <Column field="id" header="ردیف" body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column field="productName" header="نام محصول" body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column field="rating" header="امتیاز داده شده" body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column field="fullName" header="کاربر" body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column field="phoneNumber" header="شماره تماس" body={loading ? skeletonBodyTemplate : null}></Column>
                    <Column field="comment" header="کامنت" body={loading ? skeletonBodyTemplate : null} style={{ width: '30px', overflow: 'hidden', textOverflow: 'ellipsis' }}></Column>
               
                    <Column field="createDate" header="تاریخ ثبت" body={dateBodyTemplate}></Column>
                                        <Column header="عملیات" body={actionTemplate} ></Column>
                    
                </DataTable>

            </div>
        </>
    );
}

export default Banner;
